import React from "react";
import $ from "jquery";

import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Services from "../components/Services";
import Call from "../components/Call";
import Portfolio from "../components/Portfolio";
import About from "../components/About";
import Contactsent from "../components/Contactsent";
import Location from "../components/Location";
import Footer from "../components/Footer";

// import ScrollToTopOnMount from '../components/ScrollToTopOnMount'

export default class Mailsent extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div>
        {/* <ScrollToTopOnMount> */}
        <Navbar
          logo={
            $(window).width() < 767
              ? "https://www.nabytekbatka.cz/logocodeB.svg"
              : "https://www.nabytekbatka.cz/logocode.svg"
          }
          nav="menu"
        />
        <Hero />
        <Services />
        <Call />
        <Portfolio />
        <About />
        <Contactsent />
        <Location />
        <Footer />
        {/* </ScrollToTopOnMount> */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Mailsent.js